import styled from 'styled-components';

import React, { Dispatch, useRef, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';

import { AutocompleteContainer, AutocompletePopper, ListItemType } from './Base';
import { ContextMenu } from '@components/Flow';
import { NodeListItem } from './ListItem/NodeListItem';
import { InputBase } from '@mui/material';

interface Props {
  options: ListItemType[];
  disabled?: boolean;
  placeholder?: string;
  contextMenu: ContextMenu | null;
  setContextMenu: Dispatch<ContextMenu | null>;
  onChange: (event: React.SyntheticEvent<Element, Event>, newValue: any | null) => void;
}

const NodeAutocompleteInput = styled(InputBase)<{ open: boolean }>`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.line.light};
  border-radius: 8px;
  height: 50px;
  padding: 0px 13px;
  background-color: ${({ theme }) => theme.background.standard};
  font-size: 14;
  border-color: ${({ theme, open }) => (open ? theme.primary : theme.line.light)};

  & .MuiInputBase-input::placeholder {
    color: ${({ theme }) => theme.text.standard};
    font-weight: 400;
  }
`;

export const NodesAutocomplete: React.FC<Props> = ({ onChange, disabled, options, setContextMenu, placeholder }) => {
  const autocompleteRef = useRef(null);

  const [open, setOpen] = useState<boolean>(true);

  return (
    <AutocompleteContainer open={open}>
      <Autocomplete
        ref={autocompleteRef}
        onChange={(event, newValue) => {
          onChange(event, newValue);
          setOpen(false);
          (document?.activeElement as HTMLElement)?.blur();
        }}
        sx={{ minWidth: '450px', maxWidth: '450px', maxHeight: '800px' }}
        onClose={() => setContextMenu(null)}
        disabled={disabled}
        PopperComponent={AutocompletePopper}
        renderOption={(props, option) => <NodeListItem {...props} option={option} />}
        autoHighlight
        autoComplete
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        options={options}
        openOnFocus
        disablePortal
        forcePopupIcon
        groupBy={(option) => option?.metadata?.group}
        getOptionLabel={(option) => option?.label || ''}
        renderInput={(params) => (
          <NodeAutocompleteInput
            open={open}
            ref={params.InputProps.ref}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            inputProps={params.inputProps}
            placeholder={placeholder}
            disabled={disabled}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
          />
        )}
      />
    </AutocompleteContainer>
  );
};
